import I18n from 'i18n-js';
import React from 'react';
import bind from '@reverbdotcom/commons/src/bind';

interface Props {
  onUpdate: Function;
  filterByPrice?: boolean;
  priceMin?: number;
  priceMax?: number;
}

class PriceFilters extends React.Component<Props, null> {
  @bind
  togglePriceFilters(e) {
    const filterByPrice = e.target.checked;
    this.props.onUpdate({ filterByPrice });
  }

  @bind
  handlePriceMinChange(e) {
    const priceMin = e.target.value;
    this.props.onUpdate({ priceMin });
  }

  @bind
  handlePriceMaxChange(e) {
    const priceMax = e.target.value;
    this.props.onUpdate({ priceMax });
  }

  renderPriceFilters() {
    if (!this.props.filterByPrice) { return null; }

    return (
      <div className="feed-modal__switch__inputs">
        <label htmlFor="price-min">
          {I18n.t('discovery.addFollowToFeed.priceMinLabel')}
        </label>
        <input
          name="price-min"
          id="price-min"
          onChange={this.handlePriceMinChange}
          value={this.props.priceMin || ''}
          type="text"
        />
        <label htmlFor="price-max">
          {I18n.t('discovery.addFollowToFeed.priceMaxLabel')}
        </label>
        <input
          name="price-max"
          id="price-max"
          onChange={this.handlePriceMaxChange}
          value={this.props.priceMax || ''}
          type="text"
        />
      </div>
    );
  }

  render() {
    return (
      <div className="feed-modal__option">
        <div className="feed-modal__switch">
          <input
            type="checkbox"
            id="price-filter-toggle"
            onChange={this.togglePriceFilters}
            checked={this.props.filterByPrice}
          />
          <label htmlFor="price-filter-toggle">
            {I18n.t('discovery.addFollowToFeed.filterByPrice')}
          </label>
        </div>
        <form>
          {this.renderPriceFilters()}
        </form>
      </div>
    );
  }
}

export default PriceFilters;
